import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { updateProductVariations } from '@/api/products';
import { AppModule } from '@/store/modules/app';
import { Action } from 'vuex-module-decorators';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.rules = {};
  }
  get lang() {
    return AppModule.language;
  }
  activated() {}
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      await updateProductVariations(this.variations);
      this.$notify({
        title: 'Success',
        message: 'Variation updated successfully',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: null
})], default_1.prototype, "variations", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'VariationPrice'
})], default_1);
export default default_1;